import Model from './model.js';
import User from './user.js';
import Communication from './communication.js';
import Event from './event.js';

export default class Company extends Model {
	static _attributes = {
		legal_name: '',
		name: '',
		ad_name: '',
		name_short: '',
		sold_by_user_id: '',
		prospect_sales_user_id: '',
		support_user_id: '',
		industry_id: '',
		address_line_1: '',
		address_line_2: '',
		town: '',
		postcode: '',
		contact_number_1: '',
	}

	_constructor() {
		if (this.user != null) {
			this.user = new User(this.user, { $help: this.$help, vue: this.vue })
		}

		if (this.users != null) {
			this.users = User.fill(this.users, { $help: this.$help, vue: this.vue })
		}

		if (this.communications != null) {
			this.communications = Communication.fill(this.communications, {
				removed: false,
				$help: this.$help,
			})
		}

		if (this.current_task != null) {
			this.current_task = new Event(this.current_task, {
				vue: this.vue,
			})
		}

		if (this.tasks != null) {
			this.tasks = Event.fill(this.tasks, {
				vue: this.vue,
			})
		}

		if (this.appointments != null) {
			this.appointments = Event.fill(this.appointments, {
				vue: this.vue,
			})
		}
	}

	getName() {
		let n = this.legal_name != '' ? this.legal_name : this.name;

		return n != null && n != '' ? n : 'Unknown company name'
	}

	hasAddress() {
		return this.address_line_1
			|| this.address_line_2
			|| this.town
			|| this.postcode;
	}

	getAddressAsString() {
		return [this.address_line_1, this.address_line_2, this.town, this.postcode]
			.filter(x => typeof x === 'string' && x.length > 0)
			.join(", ");
	}

	getPrimaryEmail() {
		return this.communications.find(c => c.type == 1 && c.primary == 1)?.value
	}

	getPrimaryNumber() {
		return this.communications.find(c => c.type == 0 && c.primary == 1)?.value
	}

	hasLogo(tag) {
		let i = this.site.logos.find(a => a.tag == tag)

		if (i == undefined || i.file_name == '' || i.file_name == null) {
			return false;
		}

		return i.file_name.replace("public/", "https://lp.getwork.uk/storage/")
	}

	getStatusColor() {
		switch (true) {
			case this.prospect_pitch_status?.status == 'qualified':
				return 'text-purple-600 stroke-purple-600'
				break
			case this.prospect_pitch_status?.status == 'pitched':
				return 'text-red-600 stroke-red-600'
				break
			case this.prospect_pitch_status?.status == 'follow up':
				return 'text-red-600 stroke-red-600'
				break
			default:
				return 'text-blue-600 stroke-blue-600'
		}
	}

	getBackgroundColor() {
		switch (true) {
			case this.prospect_pitch_status?.status == 'qualified':
				return 'bg-purple-600'
				break
			case this.prospect_pitch_status?.status == 'pitched':
				return 'bg-red-500'
				break
			case this.prospect_pitch_status?.status == 'follow up':
				return 'bg-red-600'
				break
			default:
				return 'bg-blue-600'
		}
	}

	getStatus() {
		if (this.prospect_pitch_status == null) {
			return 'prospect'
		}

		return this.prospect_pitch_status.status
	}

	changeStatus(status) {
		if (this.prospect_pitch_status == null) {
			this.prospect_pitch_status = {
				status: status
			}
		}

		if (this.prospect_pitch_status.status != status) {
			this.prospect_pitch_status.status = status
			this.vue.$axios.post(`/admin/prospect-pitch/${this.id}`, {
				status: status
			})
		}
	}

	veriffUser() {
		return this.users.find(u => u.veriff_id != null)
	}

	statusCustomerFriendlyName() {
		if (this.status == null) {
			if (this.prospect_pitch_status == null || this.prospect_pitch_status.status == 'assigned') {
				if (this.source != '' && this.source != null) {
					return 'New '+this.source.replace('-', ' ')
				}

				return 'New lead'
			}

			return this.$help.capitalizeFirstLetter(this.prospect_pitch_status.status)
		}

		switch (this.status.status) {
			case 1: return 'New customer'; break;
			case 2: return 'Asset check'; break;
			case 3: return 'Page build'; break;
			case 4: return 'Page approval'; break;
			case 5: return 'Page approved'; break;
			case 6: return 'Campaign build'; break;
			case 7: return 'Campaign built'; break;
			case 8: return 'Launch approved'; break;
			case 9: return 'Live'; break;
			case 100: return 'Removed'; break;
		}
	}

	statusColour() {
		if (this.status == null) {
			if (this.prospect_pitch_status == null) {
				return '#DC583C'
			}

			switch (this.prospect_pitch_status.status) {
				case 'assigned': return '#DC583C'; break;
				case 'prospect': return '#00D6EC'; break;
				case 'qualified': return '#8B4DB6'; break;
				case 'pitched': return '#FFCD40'; break;
				case 'follow up': return '#FF9026'; break;
			}
		}

		switch (this.status.status) {
			case 1: return '#C9C9C9'; break;
			case 2: return '#DC583C'; break;
			case 3: return '#FF9026'; break;
			case 4: return '#FFCD40'; break;
			case 5: return '#FFCD40'; break;
			case 6: return '#00D6EC'; break;
			case 7: return '#8B4DB6'; break;
			case 8: return '#00B885'; break;
			case 9: return '#008F6B'; break;
			case 100: return '#939393'; break;
		}
	}

	title() {
		if (this.active == 0) {
			return (this.prospect_pitch_status == null || this.prospect_pitch_status.status == 'assigned') 
				? 'Lead' : 'Prospect';
		}

		return 'Company'
	}
}